import CashBack from '@/services/cashback';

const state = {
    settings: {},
    cashbacks: {},
};

const getters = {
    getCashbackSettings: state => state.settings,
    getCashbacks: state => state.cashbacks,
};

const actions = {
    async fetchCashbackSettings({ commit }) {
        const response = await CashBack.getCashBackSettings();
        commit('setCashbackSettings', response.data);
    },
    async fetchCashback({ commit }) {
        const response = await CashBack.getCashbacks();
        commit('setCashback', response.data);
    },
};

const mutations = {
    setCashbackSettings: (state, settings) => (state.settings = settings),
    setCashbacks: (state, cashbacks) => (state.cashbacks = cashbacks),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
